<template>
  <div class="row flex-grow-1 h-0 no-gutters">
    <div class="col-6 pr-2">
      <GmbSection
          :childRadioButtonActivatedValue="activatedEntityIdentifier"
          :displayLevel="1"
          height="parent"
          lockHeader
          title="Liste d'accès"
          @child-radio-button-value-changed="onActivatedEntityChanged"
      >
        <template #picto>
          <FdText colorTheme4 fa><i class="fas fa-key"/></FdText>
        </template>

        <GmbObsbox :entities="entities"/>
      </GmbSection>
    </div>

    <div class="col-6 pl-2">
      <GmbSection :displayLevel="1" height="parent" title="Détails d'accès">
        <template #picto>
          <FdText colorTheme4 fa><i class="fas fa-info-circle"/></FdText>
        </template>

        <GmbRow>
          <template #picto>
            <FdText colorTheme4 fa><i class="fas fa-eye"/></FdText>
          </template>

          <div class="d-flex flex-column">
            <FdText bold colorTheme4 tag="label">Accès</FdText>
            <FdText class="mt-1" tag="span">{{ userObservatoryAccess }}</FdText>
          </div>
        </GmbRow>

        <GmbRow class="mt-2">
          <template #picto>
            <FdText colorTheme4 fa><i class="fas fa-id-card-alt"/></FdText>
          </template>

          <div class="d-flex flex-column">
            <FdText bold colorTheme4 tag="label">Identifiant</FdText>
            <FdText class="mt-1" tag="span">{{
                activatedEntity.entityObj.frontend_controlling_user.username
              }}
            </FdText>
          </div>
        </GmbRow>

        <GmbRow v-if="activatedEntity.entityObj.self_declaration_url" class="mt-2">
          <template #picto>
            <FdText colorTheme4 fa><i class="fas fa-file-signature"/></FdText>
          </template>

          <div class="d-flex flex-column">
            <FdText bold colorTheme4 tag="label">URL d'autodéclaration</FdText>
            <FdText class="mt-1" tag="span">{{
                activatedEntity.entityObj.self_declaration_url
              }}
            </FdText>
          </div>
        </GmbRow>

      </GmbSection>
    </div>
  </div>
</template>

<script>
import {activateEntityFromList} from "@/helpers.js";

import FdText from "@/flexdesign/Text";

import GmbObsbox from "@/widgets/Obsbox";
import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";

export default {
  name: "GmbObservatoryCredentialManager",

  components: {
    FdText,
    GmbObsbox,
    GmbRow,
    GmbSection,
  },

  props: {
    entities: Array,
  },

  data() {
    return {
      activatedEntityIdentifier: undefined,
    };
  },

  computed: {
    activatedEntity() {
      // This is not the same as Observatory.activatedEntity!
      return activateEntityFromList(
          this.entities,
          this.activatedEntityIdentifier
      );
    },

    userObservatoryAccess() {
      if (this.activatedEntity)
        if (this.activatedEntity.organization)
          return "Site - " + this.activatedEntity.organization;
        else if (this.activatedEntity.project)
          return "Projet - " + this.activatedEntity.project;
        else if (this.activatedEntity.client)
          return "Client - " + this.activatedEntity.client;
      return undefined;
    },
  },

  watch: {
    entities: {
      handler: function (newEntities) {
        if (
            this.activatedEntityIdentifier == null &&
            newEntities &&
            newEntities.length
        )
          this.activatedEntityIdentifier = newEntities[0].identifier;
      },
      immediate: true,
    },
  },

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onActivatedEntityChanged(newActivatedEntity) {
      this.activatedEntityIdentifier = newActivatedEntity;
    },
  },
};
</script>

<style lang="scss"></style>
